import React, { useState } from 'react';
import { useAuth } from '../../store/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { UserPlus, ArrowLeft } from 'lucide-react';

const RegisterPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [brand, setBrand] = useState('');
  const [market, setMarket] = useState('');
  const [country, setCountry] = useState('España');
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const countries = [
    'España', 'Portugal', 'Francia', 'Italia', 'Alemania', 
    'Reino Unido', 'Marruecos', 'Estados Unidos', 'Otros'
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const result = await register(email, password, name, brand, market, country);
    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
    }
  };

  return (
    <div className="grid-bg" style={{ 
      height: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      background: 'radial-gradient(circle at center, #0B3D91 0%, #05070A 100%)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div className="scanline" />

      {/* Back to Home Button */}
      <Link to="/" style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#00CEC9',
        textDecoration: 'none',
        fontSize: '12px',
        fontWeight: 'bold',
        letterSpacing: '1px',
        textTransform: 'uppercase',
        transition: 'opacity 0.2s',
        zIndex: 10
      }}>
        <ArrowLeft size={16} /> ABORT TO BASE
      </Link>

      <div className="mission-control-card crt-effect glow-border">
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <UserPlus size={48} color="#E27B58" style={{ marginBottom: '10px' }} />
          <h2 style={{ margin: 0, letterSpacing: '2px', fontFamily: "'Orbitron', sans-serif" }}>OPPORTUNITY</h2>
          <p style={{ color: '#E27B58', fontSize: '12px', marginTop: '5px' }}>PERSONNEL ENROLLMENT</p>
        </div>

        {error && <div style={{ color: '#ff7675', marginBottom: '15px', fontSize: '14px', textAlign: 'center', background: 'rgba(255, 118, 117, 0.1)', padding: '10px' }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>FULL NAME</label>
            <input 
              type="text" 
              className="nasa-input"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>EMAIL ADDRESS</label>
            <input 
              type="email" 
              className="nasa-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>MARCA / BRAND</label>
            <input 
              type="text" 
              className="nasa-input"
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
              placeholder="Ej: McDonald's, Starbucks..."
              required
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>MERCADO / MARKET</label>
            <input 
              type="text" 
              className="nasa-input"
              value={market}
              onChange={(e) => setMarket(e.target.value)}
              placeholder="Ej: Restaurantes, Retail, Cafeterías..."
              required
            />
          </div>
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>PAÍS PRINCIPAL / PRIMARY COUNTRY</label>
            <select 
              className="nasa-input"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              style={{ padding: '10px' }}
              required
            >
              {countries.map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>
          <div style={{ marginBottom: '25px' }}>
            <label style={{ display: 'block', fontSize: '12px', marginBottom: '5px', opacity: 0.8 }}>SECURITY CODE (PASSWORD)</label>
            <input 
              type="password" 
              className="nasa-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="nasa-button" style={{ width: '100%' }}>
            ENROLL NOW
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px' }}>
          <span style={{ opacity: 0.7 }}>Already cleared? </span>
          <Link to="/login" style={{ color: '#00CEC9', textDecoration: 'none' }}>Return to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
